import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { useForm } from 'react-hook-form';
const URI = ApiEndpoint + 'configuration/';
const EditStatus = ({ idStatus, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tiposStatus, setTiposStatus] = useState(null);
  const [status, setStatus] = useState({
    descripcion: '',
    idtipostatus: 0
  });
  const [selectedTipoStatus, setSelectedTipoStatus] = useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();
  const getStatusList = async () => {
    setTiposStatus(null);

    httpClient('GET', URI + 'tiposstatus', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setTiposStatus(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getStatus = async () => {
    setStatus(null);

    httpClient('GET', URI + 'status/' + idStatus, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setSelectedTipoStatus(response.data.idtipostatus);
          setValue('descripcion', response.data.descripcion);
          setValue('idtipostatus', response.data.idtipostatus);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (idStatus > 0) getStatus();
    getStatusList();
  }, []);
  const onSubmit = data => {
    console.log(data);

    if (idStatus > 0) {
      httpClient(
        'put',
        URI + 'status/' + idStatus,
        {
          descripcion: data.descripcion,
          idtipostatus: data.idtipostatus
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'status',
        {
          descripcion: data.descripcion,
          idtipostatus: data.idtipostatus
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };

  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Status</Form.Label>
                <Form.Control
                  as="select"
                  aria-label="Default select"
                  name="idtipostatus"
                  id="idtipostatus"
                  {...register('idtipostatus', {
                    required: 'Campo Requerido'
                  })}
                  isInvalid={!!errors.idtipostatus}
                  onChange={e => {
                    setValue('idtipostatus', e.target.value, {
                      shouldValidate: true
                    });
                    setSelectedTipoStatus(e.target.value);
                  }}
                  value={`${selectedTipoStatus}`}
                  style={{ minWidth: '250px' }}
                >
                  <option key={'location_0'} value="">
                    Selecciona un tipo de status
                  </option>
                  {!!tiposStatus?.length &&
                    tiposStatus.map(tipo => (
                      <option key={tipo.idtipostatus} value={tipo.idtipostatus}>
                        {tipo.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.idtipostatus?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Descripcion</Form.Label>
                <FormControl
                  {...register('descripcion', {
                    required: 'Descripcion es requerido',
                    minLength: {
                      value: 3,
                      message: 'Descripcion debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message: 'Descripcion debe tener máximo 30 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={status?.descripcion}
                  isInvalid={!!errors.descripcion}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descripcion?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
EditStatus.propTypes = {
  idStatus: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};
export default EditStatus;
